import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const wikijs = defineConnector({
  identifier: "wikijs",
  name: "Wiki.js",
  tagLine: "Modern self-hosted wiki platform",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Wiki.js details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://wiki.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Wiki.js instance.",
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Wiki.js, go to **Administration → API Access** and create a new API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/graphql`,
  },
});
